import React, { Component } from 'react'
import ScrollAnimation from 'react-animate-on-scroll';
import Asset16 from '../Assets/img/Asset-16.png'
import Asset17 from '../Assets/img/Asset-17.png'
import Asset18 from '../Assets/img/Asset-18.png'
import Asset19 from '../Assets/img/Asset-19.png'
import Asset20 from '../Assets/img/Asset-20.png'

export class Benifit extends Component {
     
    render() {
        const styletext = { visibility: "visible", 
            duration: "500ms"
            }
        return (
            <div>
                
                
                <div className="benifits_school" id="benifits_school">
                    <div className="container">
                        <div className="row align-items-center py-lg-5 py-4">
                        
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 managment_owner" data-mdb-toggle="animation"
                                data-mdb-animation-start="onScroll" data-mdb-animation-on-scroll="repeat"
                                data-mdb-animation="slide-in-left" >
                               <ScrollAnimation animateIn='slideInLeft' animateOut='bounceOutLeft'> 
                               <img src={Asset16} className="img-fluid" />
                               </ScrollAnimation>
                               </div>
                            
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 text-center text-sm-start" data-mdb-toggle="animation"
                                data-mdb-animation-start="onScroll" data-mdb-animation-on-scroll="repeat"
                                data-mdb-animation="slide-in-right">
                                    <ScrollAnimation animateIn='slideInRight' animateOut='slideInRight'>
                                <h2>
                                    Benefits to School<br />
                                    <span>Management/Owner</span>
                                </h2>
                                <p>
                                Global reach for promoting school brand as it is fully online & web based.
One Stop Solution for all School needs.
Complete Data security.
Zero redundancy in managing the institutions records. 
Effective communication between management, teachers, parents and students. 
Complete automation of all operations. 
Best possible resource optimization.
Save a lot of investment in different softwares, servers and management issues.

                                </p>
                                </ScrollAnimation>
                            </div>
                        </div>
                        <div className="row align-items-center py-lg-5 py-0 py-sm-4">
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 order-xl-1 order-lg-1 order-md-1 order-sm-1 order-2 text-center text-sm-start" data-mdb-toggle="animation"
                                data-mdb-animation-start="onScroll" data-mdb-animation-on-scroll="repeat"
                                data-mdb-animation="slide-in-left" >
                                <ScrollAnimation animateIn='slideInLeft' animateOut='bounceOutLeft'> 
                                <h2>
                                    Benefits to School<br />
                                    <span>Administration (Admin)</span>
                                </h2>
                                <p>
                                Full Online Classroom can be an Unique Selling Point (USP) for School Marketing.
Easy performance monitoring of individual functions leading to uncomplicated error detection.
Automated and quick report generation along with negligible process turnaround time. 
Centralized data repository for trouble-free data access. 
Authenticated profile dependent access to data.
Full web control of School Transport process
Dedicated Online Payment Gateway for enabling fee collection via digital modes.
High level data security. 
Elimination of people-dependent processes. 
Minimal data redundancy.
Remote training support by RKCL.
Online/Telephonic Technical Support by RKCL.

                                </p></ScrollAnimation>
                            </div>
                            <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 order-xl-2 order-lg-2 order-md-2 order-sm-2 order-1" data-mdb-toggle="animation"
                                data-mdb-animation-start="onScroll" data-mdb-animation-on-scroll="repeat"
                                data-mdb-animation="slide-in-right">
                                <ScrollAnimation animateIn='slideInRight' animateOut='slideInRight'> 
                                <img src={Asset17} className="img-fluid" />
                                </ScrollAnimation>
                            </div>
                        </div>
                    </div>
                </div>
                

                
                <div className="benifits_table">
            <div className="container">
                <div className="row py-3">
                
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 pb-lg-0 pb-4 animation slide-in-left" data-mdb-toggle="animation" data-mdb-animation-start="onScroll" data-mdb-animation-on-scroll="repeat" data-mdb-animation="slide-in-left" style={styletext}>
                
                <div className="card pt-4 first">
                    
                    <h5 className="card-title pb-3">Benefits to Teachers</h5>
                    <img  src={Asset18} className="card-img-top" />
                    <div className="card-body uvp-list">
                        <ul>
                        <li>Computerized management of student attendance.</li>
                        <li>Computerized management of student marks, grades &amp; progress report</li>
                        <li>Timetable creation in advance along with Weekly Topic Planner</li>
                        <li>Efficient and effective interaction with parents</li>
                        <li>Access to own attendance &amp; leave records</li>
                        <li>Manage class information and analytical reports</li>
                        <li>E-mail &amp; Internal messaging system</li>
                        <li>Upload Content on inbuilt LMS for students.</li>
                        <li>Ability to take Online Classrooms &amp; conduct video calls</li>
                        </ul>
                    </div>
                    
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-6 col-sm-6 pb-lg-0 pb-4">
                    <div className="card pt-4">
                    <h5 className="card-title pb-3">Benefits to Students</h5>
                    <img src={Asset19} className="card-img-top" />
                    <div className="card-body uvp-list">
                        <ul>
                        <li>Enhanced interaction with teachers, parents &amp; peers.</li>
                        <li>Content access on LMS.</li>
                        <li>Access to attendance, timetable, marks, grades, progress report and examination schedule.</li>
                        <li>Freedom to browse through library books catalogue and identify the book(s) to be issued.</li>
                        <li>Prior information about school events and holidays.</li>
                        <li>Android App to access school notifications, profile details and assignments.</li>
                        
                        </ul>
                    </div>
                    </div>
                </div>
                <div className="col-xl-4 col-lg-4 col-md-12 col-sm-12 pb-0 animation slide-in-right" data-mdb-toggle="animation" data-mdb-animation-start="onScroll" data-mdb-animation-on-scroll="repeat" data-mdb-animation="slide-in-right">
                
                    <div className="card pt-4 third">
                    <h5 className="card-title pb-3">Benefits to Parents</h5>
                    <img src={Asset20} className="card-img-top" />
                    <div className="card-body uvp-list">
                        <ul>
                        <li>Get connected to the school effectively and easily</li>
                        <li>Flexibility to pay fees using Digital modes</li>
                        <li>Frequent interaction with teachers</li> 
                        <li>Reliable updates on child's attendance, leaves, progress report and fee payment.</li>
                        <li>Prior information about school events and holidays</li>
                        <li>Easy Request for Character Certificate, Transfer Certificate, etc.</li>
                        </ul>
                    </div>
                    </div>
                
                </div>
                </div>
            </div>
            </div>

            </div>
        )
    }
}

export default Benifit
